module.exports = __webpack_public_path__ + "static/media/login.8b368cd1.svg";